(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_wim-header-menu"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('winery-menu-drawer')) {
    customElements.define(
      'winery-menu-drawer',
      class extends HTMLElement {
        #dialog = null;
        #toggle = null;
        #closeBtn = null;
        #handlers = [];

        connectedCallback() {
          this.#dialog = this.querySelector('.winery-menu-drawer__dialog');
          if (!this.#dialog) return;

          this.#closeBtn = this.#dialog.querySelector('.winery-menu-drawer__close');

          const id = this.getAttribute('id');
          if (id) {
            this.#toggle = document.querySelector(`[aria-controls="${CSS.escape(id)}"]`);
          }

          if (this.#toggle) this.#on(this.#toggle, 'click', (e) => this.#open(e));
          if (this.#closeBtn) this.#on(this.#closeBtn, 'click', () => this.#close());
          this.#on(this.#dialog, 'click', (e) => {
            if (e.target === this.#dialog) this.#close();
          });
          this.#on(this.#dialog, 'close', () => this.#onClosed());
        }

        disconnectedCallback() {
          for (const [el, evt, fn] of this.#handlers) el.removeEventListener(evt, fn);
          this.#handlers.length = 0;
        }

        #on(el, evt, fn) {
          el.addEventListener(evt, fn);
          this.#handlers.push([el, evt, fn]);
        }

        #open(event) {
          event?.preventDefault();
          if (!this.#dialog?.showModal || this.#dialog.open) return;
          try {
            this.#dialog.showModal();
          } catch {
            return;
          }
          this.#toggle?.setAttribute('aria-expanded', 'true');
          document.documentElement.classList.add('is-drawer-open');
        }

        #close() {
          if (this.#dialog?.open) this.#dialog.close();
        }

        #onClosed() {
          if (this.#toggle) {
            this.#toggle.setAttribute('aria-expanded', 'false');
            try {
              this.#toggle.focus({ preventScroll: true });
            } catch {
              this.#toggle.focus();
            }
          }
          document.documentElement.classList.remove('is-drawer-open');
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
